export const STORE_BOTTOM_NAV_ROOTS = [
  '/search',
  '/orders',
  '/wishlist',
  '/cart',
] as const

export type StoreNavLocationState = {
  fromBottomNav?: boolean
}

export function storeBottomNavState(): StoreNavLocationState {
  return { fromBottomNav: true }
}

export function isStoreBottomNavRoot(pathname: string): boolean {
  return (STORE_BOTTOM_NAV_ROOTS as readonly string[]).includes(pathname)
}

export function enteredViaBottomNav(state: unknown): boolean {
  return (state as StoreNavLocationState | null)?.fromBottomNav === true
}

const STORE_TAB_BOTTOM_NAV_KEY = 'store-tab-bottom-nav'

/** Call synchronously from bottom-nav clicks before navigation runs. */
export function markStoreTabFromBottomNav(pathname: string): void {
  if (typeof sessionStorage === 'undefined') return
  if (!isStoreBottomNavRoot(pathname)) return
  sessionStorage.setItem(STORE_TAB_BOTTOM_NAV_KEY, pathname)
}

export function syncStoreTabBottomNavMark(
  pathname: string,
  state: unknown
): void {
  if (typeof sessionStorage === 'undefined') return

  if (!isStoreBottomNavRoot(pathname)) {
    sessionStorage.removeItem(STORE_TAB_BOTTOM_NAV_KEY)
    return
  }

  if (enteredViaBottomNav(state)) {
    sessionStorage.setItem(STORE_TAB_BOTTOM_NAV_KEY, pathname)
  }
}

function markedStoreTabFromBottomNav(pathname: string): boolean {
  if (typeof sessionStorage === 'undefined') return false
  return sessionStorage.getItem(STORE_TAB_BOTTOM_NAV_KEY) === pathname
}

export function shouldHideBackOnStoreTab(
  pathname: string,
  state: unknown
): boolean {
  if (!isStoreBottomNavRoot(pathname)) return false
  return enteredViaBottomNav(state) || markedStoreTabFromBottomNav(pathname)
}

export function resolveStoreBackNav(pathname: string): {
  to: string
  label: string
} | null {
  if (pathname === '/' || pathname === '') return null

  if (/^\/orders\/[^/]+$/.test(pathname)) {
    return { to: '/orders', label: 'Back to orders' }
  }

  if (pathname === '/checkout') {
    return { to: '/cart', label: 'Back to cart' }
  }

  if (pathname === '/order-success') {
    return { to: '/orders', label: 'Back to orders' }
  }

  return { to: '/', label: 'Back to home' }
}
